module.exports = __webpack_public_path__ + "static/media/up.53c74c36.svg";